import React from 'react';
import styles from '../static/css/header.module.css'
import logo from '../static/images/logo.png'
import azadi from '../static/images/azadiLogo.png'

function Header() {
    return (
        <div className={styles.container}>
            <img
                className={styles.sebilogo}
                src={logo}
                alt="Sebi Logo"
            />
            <img
                className={styles.azadilogo}
                src={azadi}
                alt="Azadi Logo"
            />
        </div>
    )
}

export default Header